module.exports = __webpack_public_path__ + "img/gouwuche.47202fd3.png";